/**
 * NSM dari ERKAM bisa tersimpan dengan spasi (mis. "121215030036 "),
 * sedangkan backend EDM mencocokkan NSM secara exact-match.
 * Hapus seluruh whitespace (termasuk NBSP) supaya NSM yang dikirim selalu konsisten.
 */
export const normalizeNsm = (nsm: string | null | undefined): string =>
	String(nsm ?? '').replace(/\s+/g, '');

const isPlainObject = (value: unknown): value is Record<string, unknown> =>
	Object.prototype.toString.call(value) === '[object Object]';

/**
 * Normalisasi seluruh field `nsm` (termasuk yang bersarang di object/array)
 * pada params atau body request tanpa mengubah object aslinya.
 */
export const normalizeNsmInPayload = <T>(payload: T): T => {
	if (typeof FormData !== 'undefined' && payload instanceof FormData) {
		const nsm = payload.get('nsm');
		if (typeof nsm === 'string') {
			payload.set('nsm', normalizeNsm(nsm));
		}
		return payload;
	}

	if (Array.isArray(payload)) {
		return payload.map((item) => normalizeNsmInPayload(item)) as T;
	}

	if (isPlainObject(payload)) {
		return Object.fromEntries(
			Object.entries(payload).map(([key, value]) => [
				key,
				key === 'nsm' && typeof value === 'string'
					? normalizeNsm(value)
					: normalizeNsmInPayload(value),
			])
		) as T;
	}

	return payload;
};
